import { LoginApi } from "@clients/aggrego-proxy";

export class LogoutUseCase {
  constructor(private readonly loginClient: LoginApi) {}

  public async execute() {
    return await this.loginClient.refreshSessionToken({ token: undefined });
  }
}
